module.exports = __webpack_public_path__ + "static/InsightsHeroShape-fec485884bece0a426b94ac22a9be855.png";